import { isB2C } from '@/core/settings/utils';

export const GTM_DISPLAY_BRANDS = () => ({
  event: 'interaction_display homepage brand block',
  amp_event_name: 'Display homepage brand block',
  event_trigger: isB2C() ? 'homepage b2c' : 'homepage b2b',
  page_type: 'home',
});
